import { TradingOfferOperationStatus } from 'types/TradingOfferOperation';

export const isTerminalStatus = (status: TradingOfferOperationStatus) =>
  status === TradingOfferOperationStatus.COMPLETED ||
  status === TradingOfferOperationStatus.CANCELLED ||
  status === TradingOfferOperationStatus.REJECTED;
